var map = {
	"./fonts/Myriad Pro/MyriadPro-Black.otf": 8367,
	"./fonts/Myriad Pro/MyriadPro-BlackCond.otf": 5487,
	"./fonts/Myriad Pro/MyriadPro-BlackCondIt.otf": 9284,
	"./fonts/Myriad Pro/MyriadPro-BlackIt.otf": 8868,
	"./fonts/Myriad Pro/MyriadPro-BlackSemiCn.otf": 674,
	"./fonts/Myriad Pro/MyriadPro-BlackSemiCnIt.otf": 1733,
	"./fonts/Myriad Pro/MyriadPro-BlackSemiExt.otf": 6540,
	"./fonts/Myriad Pro/MyriadPro-BlackSemiExtIt.otf": 3071,
	"./fonts/Myriad Pro/MyriadPro-Bold.otf": 1929,
	"./fonts/Myriad Pro/MyriadPro-BoldCond.otf": 2509,
	"./fonts/Myriad Pro/MyriadPro-BoldCondIt.otf": 6586,
	"./fonts/Myriad Pro/MyriadPro-BoldIt.otf": 8126,
	"./fonts/Myriad Pro/MyriadPro-BoldSemiCn.otf": 1520,
	"./fonts/Myriad Pro/MyriadPro-BoldSemiCnIt.otf": 7355,
	"./fonts/Myriad Pro/MyriadPro-BoldSemiExt.otf": 3622,
	"./fonts/Myriad Pro/MyriadPro-BoldSemiExtIt.otf": 2097,
	"./fonts/Myriad Pro/MyriadPro-Cond.otf": 9152,
	"./fonts/Myriad Pro/MyriadPro-CondIt.otf": 2043,
	"./fonts/Myriad Pro/MyriadPro-It.otf": 9675,
	"./fonts/Myriad Pro/MyriadPro-Light.otf": 4506,
	"./fonts/Myriad Pro/MyriadPro-LightCond.otf": 3414,
	"./fonts/Myriad Pro/MyriadPro-LightCondIt.otf": 6337,
	"./fonts/Myriad Pro/MyriadPro-LightIt.otf": 493,
	"./fonts/Myriad Pro/MyriadPro-LightSemiCn.otf": 2971,
	"./fonts/Myriad Pro/MyriadPro-LightSemiCnIt.otf": 4264,
	"./fonts/Myriad Pro/MyriadPro-LightSemiExt.otf": 5067,
	"./fonts/Myriad Pro/MyriadPro-LightSemiExtIt.otf": 536,
	"./fonts/Myriad Pro/MyriadPro-Regular.otf": 4234,
	"./fonts/Myriad Pro/MyriadPro-SemiCn.otf": 2581,
	"./fonts/Myriad Pro/MyriadPro-SemiCnIt.otf": 3058,
	"./fonts/Myriad Pro/MyriadPro-SemiExt.otf": 2001,
	"./fonts/Myriad Pro/MyriadPro-SemiExtIt.otf": 342,
	"./fonts/Myriad Pro/MyriadPro-Semibold.otf": 343,
	"./fonts/Myriad Pro/MyriadPro-SemiboldCond.otf": 8391,
	"./fonts/Myriad Pro/MyriadPro-SemiboldCondIt.otf": 1916,
	"./fonts/Myriad Pro/MyriadPro-SemiboldIt.otf": 5020,
	"./fonts/Myriad Pro/MyriadPro-SemiboldSemiCn.otf": 9642,
	"./fonts/Myriad Pro/MyriadPro-SemiboldSemiCnIt.otf": 8717,
	"./fonts/Myriad Pro/MyriadPro-SemiboldSemiExt.otf": 9476,
	"./fonts/Myriad Pro/MyriadPro-SemiboldSemiExtIt.otf": 4407,
	"./fonts/Tungsten/Tungsten-Medium.ttf": 5786,
	"./fonts/index.css": 26,
	"./images/AI_TWIN/AI_TWIN_DEMO_1_character.png": 7278,
	"./images/AI_TWIN/AI_TWIN_DEMO_2_bubble_1.png": 6020,
	"./images/AI_TWIN/AI_TWIN_DEMO_2_bubble_2.png": 6863,
	"./images/AI_TWIN/AI_TWIN_DEMO_2_bubble_3.png": 7846,
	"./images/AI_TWIN/AI_TWIN_DEMO_3_bubble_1.png": 8159,
	"./images/AI_TWIN/AI_TWIN_DEMO_3_bubble_2.png": 3508,
	"./images/AI_TWIN/AI_TWIN_DEMO_3_bubble_3.png": 3453,
	"./images/AI_TWIN/AI_TWIN_DEMO_3_bubble_4.png": 946,
	"./images/AI_TWIN/AI_TWIN_DEMO_3_checkmark.png": 6414,
	"./images/AI_TWIN/AI_TWIN_DEMO_3_computer.png": 6850,
	"./images/AI_TWIN/AI_TWIN_DEMO_4_bell.png": 4611,
	"./images/AI_TWIN/AI_TWIN_DEMO_4_bubble_1.png": 2522,
	"./images/AI_TWIN/AI_TWIN_DEMO_4_bubble_2.png": 8769,
	"./images/AI_TWIN/AI_TWIN_DEMO_4_bubble_3.png": 376,
	"./images/AI_TWIN/AI_TWIN_DEMO_4_bubble_4.png": 9991,
	"./images/AI_TWIN/AI_TWIN_DEMO_4_bubble_5.png": 4206,
	"./images/AI_TWIN/AI_TWIN_DEMO_4_computer.png": 8867,
	"./images/AI_TWIN/AI_TWIN_DEMO_5_bubble_1.png": 557,
	"./images/AI_TWIN/AI_TWIN_DEMO_5_bubble_2.png": 8934,
	"./images/AI_TWIN/AI_TWIN_DEMO_5_bubble_3.png": 5263,
	"./images/AI_TWIN/AI_TWIN_DEMO_5_computer.png": 1452,
	"./images/AI_TWIN/AI_TWIN_DEMO_5_eye.png": 3920,
	"./images/AI_TWIN/AI_TWIN_DEMO_6_bubble_1.png": 8080,
	"./images/AI_TWIN/AI_TWIN_DEMO_6_bubble_2.png": 1579,
	"./images/AI_TWIN/AI_TWIN_DEMO_6_bubble_3.png": 450,
	"./images/AI_TWIN/AI_TWIN_DEMO_6_bubble_4.png": 6797,
	"./images/AI_TWIN/AI_TWIN_DEMO_computer.png": 2428,
	"./images/AI_TWIN/AI_Twin_01.png": 6830,
	"./images/AI_TWIN/AI_Twin_02.png": 7829,
	"./images/AI_TWIN/AI_Twin_03.png": 8732,
	"./images/AI_TWIN/AI_Twin_04.png": 8899,
	"./images/AI_TWIN/AI_Twin_05.png": 7674,
	"./images/AI_TWIN/AI_Twin_06.png": 1489,
	"./images/AI_TWIN/character_5.png": 1976,
	"./images/DNA1/DNA1_DOW_DEMO_01_CHARACTER.png": 3311,
	"./images/DNA1/DNA1_DOW_DEMO_02_Board.png": 3761,
	"./images/DNA1/DNA1_DOW_DEMO_02_PopUp.png": 1499,
	"./images/DNA1/DNA1_DOW_DEMO_03_Computer.png": 6049,
	"./images/DNA1/DNA1_DOW_DEMO_03_PopUp_1.png": 6474,
	"./images/DNA1/DNA1_DOW_DEMO_03_PopUp_2.png": 3905,
	"./images/DNA1/DNA1_DOW_DEMO_04_Computer.png": 6580,
	"./images/DNA1/DNA1_DOW_DEMO_04_PopUp_1.png": 3169,
	"./images/DNA1/DNA1_DOW_DEMO_04_PopUp_2.png": 6922,
	"./images/DNA1/DNA1_DOW_DEMO_05_Computer.png": 4731,
	"./images/DNA1/DNA1_DOW_DEMO_05_PopUp_1.png": 3180,
	"./images/DNA1/DNA1_DOW_DEMO_05_PopUp_2.png": 7463,
	"./images/DNA1/DNA1_DOW_DEMO_06_CHARACTER.png": 1564,
	"./images/DNA1/DNA1_DOW_DEMO_07_Computer.png": 1173,
	"./images/DNA1/DNA1_DOW_DEMO_07_PopUp_1.png": 646,
	"./images/DNA1/DNA1_DOW_DEMO_07_PopUp_2.png": 2413,
	"./images/DNA1/DNA1_DOW_DEMO_07_PopUp_3.png": 9172,
	"./images/DNA1/DNA1_DOW_DEMO_Video_bg.png": 4555,
	"./images/DNA1/DNA1_INTRO_1_Cycle.png": 4668,
	"./images/DNA1/DNA1_demo_1_name.png": 6624,
	"./images/DNA1/DNA1_demo_2_name.png": 1985,
	"./images/DNA1/DNA1_intro_01.jpg": 4549,
	"./images/DNA1/DNA1_intro_02.jpg": 1946,
	"./images/DNA1/DNA1_intro_03.jpg": 6407,
	"./images/DNA1/DNA1_intro_04.jpg": 2060,
	"./images/DNA1/DNA1_intro_04.png": 7208,
	"./images/DNA2/DNA2_DOW_DEMO_01_CHARACTER.png": 7249,
	"./images/DNA2/DNA2_DS_DEMO_02_bubble_1.png": 122,
	"./images/DNA2/DNA2_DS_DEMO_02_bubble_2.png": 9105,
	"./images/DNA2/DNA2_DS_DEMO_02_bubble_3.png": 4488,
	"./images/DNA2/DNA2_DS_DEMO_02_computer.png": 7699,
	"./images/DNA2/DNA2_DS_DEMO_02_list.png": 2416,
	"./images/DNA2/DNA2_DS_DEMO_03_alert.png": 9541,
	"./images/DNA2/DNA2_DS_DEMO_03_check.png": 5015,
	"./images/DNA2/DNA2_DS_DEMO_03_computer.png": 2028,
	"./images/DNA2/DNA2_DS_DEMO_03_eye.png": 9328,
	"./images/DNA2/DNA2_DS_DEMO_04_check.png": 6616,
	"./images/DNA2/DNA2_DS_DEMO_04_computer.png": 2681,
	"./images/DNA2/DNA2_DS_DEMO_04_eye.png": 4755,
	"./images/DNA2/DNA2_DS_DEMO_04_screen.png": 3994,
	"./images/DNA2/DNA2_DS_DEMO_05_bubble_1.png": 9631,
	"./images/DNA2/DNA2_DS_DEMO_05_bubble_2.png": 724,
	"./images/DNA2/DNA2_DS_DEMO_05_bubble_3.png": 1853,
	"./images/DNA2/DNA2_DS_DEMO_05_computer.png": 6354,
	"./images/DNA2/DNA2_DS_DEMO_06_bubble_1.png": 2270,
	"./images/DNA2/DNA2_DS_DEMO_06_bubble_2.png": 101,
	"./images/DNA2/DNA2_DS_DEMO_06_computer.png": 1087,
	"./images/DNA2/DNA2_DS_DEMO_07_Character.png": 2334,
	"./images/DNA2/DNA2_DS_DEMO_08_bubble_accuracy.png": 4214,
	"./images/DNA2/DNA2_DS_DEMO_08_bubble_automation.png": 1532,
	"./images/DNA2/DNA2_DS_DEMO_08_bubble_innovation.png": 5512,
	"./images/DNA2/DNA2_DS_DEMO_08_bubble_speed.png": 6828,
	"./images/DNA2/DNA2_DS_DEMO_08_computer.png": 4357,
	"./images/DNA2/DNA2_DS_DEMO_08_screen.png": 1334,
	"./images/DNA2/DNA2_DS_DEMO_09_bubble.png": 767,
	"./images/DNA2/DNA2_DS_DEMO_09_computer.png": 7214,
	"./images/DNA2/DNA2_DS_DEMO_09_screen.png": 1057,
	"./images/DNA2/DNA2_demo1_name.png": 8627,
	"./images/DNA2/DNA2_demo2_name.png": 4038,
	"./images/DNA2/DNA2_intro_01.jpg": 3971,
	"./images/DNA2/DNA2_intro_02.jpg": 7908,
	"./images/DNA2/DNA2_intro_03.jpg": 2241,
	"./images/DNA2/DNA2_intro_04.jpg": 3986,
	"./images/EV/EV_demo_Intro_01.png": 743,
	"./images/EV/EV_demo_Intro_02.png": 2012,
	"./images/EV/EV_demo_Intro_03.png": 9525,
	"./images/EV/EV_demo_Intro_04.png": 1210,
	"./images/EV/EV_demo_Intro_05.png": 1971,
	"./images/EV/EV_demo_Intro_06.png": 1128,
	"./images/EV/EV_demo_Intro_07.png": 193,
	"./images/EV/EV_demo_Intro_08.png": 1657,
	"./images/EV/EV_demo_Intro_09.png": 9135,
	"./images/EV/EV_demo_end_QR.png": 4564,
	"./images/EV/EV_demo_use_case_01.png": 5341,
	"./images/EV/EV_demo_use_case_02.png": 4134,
	"./images/EV/EV_demo_use_case_03.png": 3151,
	"./images/EV/EV_demo_use_case_04.png": 928,
	"./images/EV/EV_demo_use_case_05.png": 7177,
	"./images/EV/EV_intro_QR.png": 1139,
	"./images/EV/EV_intro_cycle.png": 1782,
	"./images/EV/EV_intro_logo.png": 491,
	"./images/EV/EV_intro_logo_2.png": 1404,
	"./images/EV/EV_use_cases_right_image.png": 8021,
	"./images/EV/UseCase_1.png": 1566,
	"./images/EV/UseCase_3.png": 7132,
	"./images/EV/UseCase_4.png": 4531,
	"./images/EV/UseCase_5.png": 8970,
	"./images/EdgeverveLogo.png": 9839,
	"./images/InfosysTopazLogo.png": 8499,
	"./images/characters/character_1.png": 4971,
	"./images/characters/character_2.png": 6640,
	"./images/characters/character_3.png": 7817,
	"./images/characters/character_4.png": 1638,
	"./images/characters/character_5.png": 7967,
	"./images/characters/character_dna1_1.gif": 2195,
	"./images/characters/character_dna1_2.gif": 7948,
	"./images/characters/character_dna2_1.gif": 6400,
	"./images/characters/character_dna2_2.gif": 7063,
	"./images/icons_labels/start.png": 3518,
	"./videos/CORAL_1_1.mp4": 4779,
	"./videos/DNA1/DNA1_DOW_DEMO_08_video.mp4": 5753,
	"./videos/DNA1/DNA1_DOW_DEMO_09_video.mp4": 2356,
	"./videos/DNA1/DNA1_DOW_DEMO_10_video.mp4": 2686,
	"./videos/EV/Use_case_1_demo.mp4": 7352,
	"./videos/EV/Use_case_1_exp.mp4": 1512,
	"./videos/EV/Use_case_2_demo.mp4": 4553,
	"./videos/EV/Use_case_2_exp.mp4": 3731,
	"./videos/EV/Use_case_3_demo.mp4": 2838,
	"./videos/EV/Use_case_3_exp.mp4": 9646,
	"./videos/EV/Use_case_4_exp.mp4": 9865,
	"./videos/EV/Use_case_5_demo.mp4": 7364
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4082;